// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { NewsThemeInfoResponseDTO } from "../../api/backend-openapi";

export const setNewsThemes = createEvent<NewsThemeInfoResponseDTO[]>(
  "SET_NEWS_THEMES"
);
export const addNewsTheme = createEvent<NewsThemeInfoResponseDTO>(
  "ADD_NEWS_THEME"
);
export const deleteNewsTheme = createEvent<string>("DELETE_NEWS_THEME");
export const updateNewsTheme = createEvent<NewsThemeInfoResponseDTO>(
  "UPDATE_NEWS_THEME"
);
